import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import industryAutomation from "../assests/revamp/industry-automation.png";
import industryAviation from "../assests/revamp/industry-aviation.png";
import industryFinance from "../assests/revamp/industry-finance.png";
import industryFood from "../assests/revamp/industry-food.png";
import industryMarine from "../assests/revamp/industry-marine.png";
import industryEnergy from "../assests/revamp/industry-energy.png";
import industryTech from "../assests/revamp/industry-tech.png";
import { useLanguage } from "../i18n/LanguageContext";

const INDUSTRIES = [
  { id: "automation", image: industryAutomation },
  { id: "aviation", image: industryAviation },
  { id: "finance", image: industryFinance },
  { id: "food", image: industryFood },
  { id: "marine", image: industryMarine },
  { id: "energy", image: industryEnergy },
  { id: "tech", image: industryTech },
];

export default function Industries() {
  const { t, copy } = useLanguage();
  const [activeIndustryIndex, setActiveIndustryIndex] = useState(0);

  const handleEnquire = (event, label) => {
    event.stopPropagation();
    window.sessionStorage.setItem("amgEnquiryIndustry", label);
    const getInTouchSection = document.getElementById("contact_us");
    if (getInTouchSection) {
      const topOffset = getInTouchSection.offsetTop - 90;
      window.scrollTo({
        top: topOffset,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
      delay: 100,
      once: true,
    });
  }, []);

  return (
    <div className="chooseUsMain amgIndustriesSection" id="industries">
      <div data-aos="fade-up" className="amgIndustriesIntro">
        <h2 className="industriesHead">{t("industries.heading")}</h2>
        <p className="amgIndustriesLead">{t("industries.lead")}</p>
      </div>

      <div data-aos="fade-up" className="amgIndustryStrip">
        {INDUSTRIES.map((industry, index) => {
          const copyItem = copy.industries.items[industry.id];
          const isActive = activeIndustryIndex === index;
          return (
            <div
              key={industry.id}
              role="button"
              tabIndex={0}
              className={
                isActive
                  ? "amgIndustryPanel amgIndustryPanel--active"
                  : "amgIndustryPanel"
              }
              style={{ backgroundImage: `url(${industry.image})` }}
              onClick={() => setActiveIndustryIndex(index)}
              onMouseEnter={() => setActiveIndustryIndex(index)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  setActiveIndustryIndex(index);
                }
              }}
              aria-pressed={isActive}
            >
              <div className="amgIndustryPanelContent">
                <span className="amgIndustryPanelLabel">{copyItem.label}</span>
                {isActive ? (
                  <>
                    <p className="amgIndustryPanelBlurb">{copyItem.blurb}</p>
                    <button
                      type="button"
                      className="amgIndustryPanelCta"
                      onClick={(event) => handleEnquire(event, copyItem.label)}
                    >
                      {t("industries.enquire")}
                    </button>
                  </>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
